module.exports = __webpack_public_path__ + "static/media/toy-shop.ac3d545c.png";